import { render, staticRenderFns } from "./WorkSpaceMainDashBoard.vue?vue&type=template&id=77a18f2e&scoped=true&"
import script from "./WorkSpaceMainDashBoard.vue?vue&type=script&lang=js&"
export * from "./WorkSpaceMainDashBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a18f2e",
  null
  
)

export default component.exports